import { render, staticRenderFns } from "./PatientCreate.vue?vue&type=template&id=7b3d1fb8&"
import script from "./PatientCreate.vue?vue&type=script&lang=ts&"
export * from "./PatientCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports